import { removeCharacter } from "../removeCharacter";

/** Function used to generate a unique id with a custom prefix. */
export const getUniqueId = (prefix) => removeCharacter(`${prefix}-${Math.random()}`, ".");
